import { render, staticRenderFns } from "./getCityplatformFee.vue?vue&type=template&id=1dbd7a17&scoped=true&"
import script from "./getCityplatformFee.vue?vue&type=script&lang=js&"
export * from "./getCityplatformFee.vue?vue&type=script&lang=js&"
import style0 from "./getCityplatformFee.vue?vue&type=style&index=0&id=1dbd7a17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbd7a17",
  null
  
)

export default component.exports